import React, { useState } from "react";
import Header from "../../components/common/header/Header";
import Layout from "components/common/layout/Layout";
import { useTranslation } from "react-i18next";

const UnauthorizedUser = () => {
  const { t } = useTranslation();
  return (
    <div
      className="d-flex justify-content-center align-items-center flex-column"
      style={{ height: "100vh", width: "100vw" }}
    >
      <img src={"/assets/icons/access.png"} />
      <h4 className="fw-bold">{t("access-denied")}</h4>
      <p>{t("access-denied-msg")}</p>
    </div>
  );
};

export default UnauthorizedUser;
